import { IDataStorage } from "../internal/data-storage";
import { InternalIndex } from "../internal/internal-index";
import { InternalTable } from "../internal/internal-table";

export class Patient implements IDataStorage {
  CaseNumberIndex: InternalIndex = new InternalIndex(
    "CaseNumber",
    "CaseNumber",
    true,
    false
  );
  tableDefinition: InternalTable = new InternalTable("Patients", "Id", true, [
    this.CaseNumberIndex,
  ]);

  Id: number;
  ReferenceId: string;
  CreatedTime: Date;
  CreatedByUserId: string;
  AdmittedDate: Date;
  Discharged: boolean;
  DischargedDate: Date;
  UpdatedTime: Date;
  UpdatedByUserId: string;
  Name: string;
  PhysicalLocationId: number;
  Bed: number;
  Room: number;
  CaseNumber: string;
  PatientStatus: string;
  AttendingPhysicianId: number;
  AttendingPhysicianTitle: string;
  AttendingPhysicianName: string;
  AttendingPhysicianTelephoneNumber: string;
  Department: string;
  NursingOrganizationUnit: string;
  MedicalAidDescription:string;
  CanBeMovedToICU: boolean;
  LastScored: Date;
  LastScore: string;

  static getTableDefinition(): InternalTable {
    return new Patient().tableDefinition;
  }
}
